import { Module } from 'vuex'

import { RecommendState, RootState } from '@/types/store'

import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const state: RecommendState = {
  recommends: [],
  isRecommendsLoading: false,
}

export const recommend: Module<RecommendState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
